import { Row, Col, Container } from "reactstrap";
import AppNavbarLight from "./AppNavbarLight";
import Footer from "./Footer";
const WithNavAndFooter = ({ children }) => {
  return (
    <Container>
      <Row>
        <Col md="12">
          <AppNavbarLight />
        </Col>
      </Row>
      {children}
      <Row>
        <Col>
          <Footer />
        </Col>
      </Row>
    </Container>
  );
};

export default WithNavAndFooter;
